<dialog id-verification-modal>
	<div class="relative overflow-hidden border-0">
		<div class="flex flex-col justify-center items-center">
			<div *ngIf="!countdown" class="h-[54px] w-[55px] flex flex-wrap relative">
				<div class="flex flex-wrap p-[12px] w-full h-full">
					<svg class="w-full h-full" xmlns="http://www.w3.org/2000/svg" width="53" height="54" viewBox="0 0 53 54" fill="none">
						<path d="M37.3537 28.9456L36.4137 17.4961H30.7442C30.7442 17.4961 26.426 26.3102 26.0441 27.5107H25.9853L21.4321 17.4961H15.7332L14.7931 27.4229L14 37.4961H17.4663C18.9645 37.4961 19.552 36.8519 19.6695 35.2706C19.6695 35.2706 20.257 26.0466 20.1689 24.6996H20.2277L20.4039 25.3145C20.6389 26.1345 23.8703 34.0115 23.8703 34.0115H28.1297C28.1297 34.0115 31.3611 26.2516 31.7723 24.6996H31.8311L32.3305 35.2706C32.448 36.8519 33.0649 37.4961 34.5337 37.4961H38L37.3537 28.9456Z" fill="#0361F0"/>
						<path opacity="0.2" d="M52.9961 27C52.9961 41.6334 41.1334 53.4961 26.5 53.4961C11.8666 53.4961 0.00390625 41.6334 0.00390625 27C0.00390625 12.3666 11.8666 0.503906 26.5 0.503906C41.1334 0.503906 52.9961 12.3666 52.9961 27ZM3.71336 27C3.71336 39.5847 13.9153 49.7866 26.5 49.7866C39.0847 49.7866 49.2866 39.5847 49.2866 27C49.2866 14.4153 39.0847 4.21336 26.5 4.21336C13.9153 4.21336 3.71336 14.4153 3.71336 27Z" fill="#0361F0"/>
					</svg>
				</div>
				<svg class="spinner col-span-full row-span-full" viewBox="0 0 38 38">
					<circle class="path" cx="19" cy="19" r="14" fill="none" stroke-width="3"></circle>
				</svg>
			</div>
			<div *ngIf="!countdown"
				 class="text-[12px] font-semibold leading-[16.8px] text-center text-[#1A1A1A]">
				Verifying your ID, <br />
				please hold on...
			</div>
			<div class="flex flex-col gap-[47px]" *ngIf="countdown">
				<div class="text-[14px] max-w-[196px] mx-auto font-semibold leading-[19.6px] text-center text-[#1A1A1A]">
					This is taking longer than<br />
					expected, please hold on...
				</div>
				<div class="mobile-preloader">
					<div class="content">
					<svg width="351" height="352" viewBox="0 0 351 352" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g filter="url(#filter0_dd_10668_204687)">
							<circle cx="177.203" cy="158.824" r="135" fill="#F9F9F9"/>
						</g>
						<circle opacity="0.3" cx="131.351" cy="131.351" r="119.851" transform="matrix(-1 0 0 1 307.203 25.8242)" stroke="#0361F0" stroke-width="23" stroke-dasharray="1 7"/>
						<path d="M175.949 37.3242C151.724 37.3242 128.068 44.6653 108.099 58.3797C88.1294 72.0941 72.7849 91.538 64.0879 114.148C55.391 136.758 53.7498 161.473 59.3809 185.035C65.012 208.596 77.6508 229.898 95.6314 246.133C113.612 262.367 136.09 272.772 160.102 275.975C184.115 279.178 208.534 275.029 230.142 264.075C251.749 253.122 269.529 235.877 281.14 214.616C292.75 193.354 297.644 169.073 295.178 144.974" stroke="url(#paint0_linear_10668_204687)" stroke-width="23" stroke-linecap="round"/>
					</svg>
					<div class="mobile-spinner">
						<svg xmlns="http://www.w3.org/2000/svg"
							 viewBox="-1 -1 34 34" stroke="url(#paint0_linear_33920_26138)">
							<circle [ngStyle]="progressStyle" id="js-progress-bar" cx="16" cy="16" r="15.9155"
									class="progress-bar-progress" />
							<defs>
								<linearGradient id="paint0_linear_33920_26138" x1="256.449" y1="186.175" x2="13.8485" y2="0.824158" gradientUnits="userSpaceOnUse">
									<stop stop-color="#002E82"/>
									<stop offset="1" stop-color="#0361F0"/>
								</linearGradient>
							</defs>
						</svg>
					</div>
					<div class="flex gap-[8px] items-center text-content">
							<div class="flex flex-col text-center">
								<div class="text-[#1A0C2F] leading-normal text-[40px] font-bold">
									{{countdown?.minute | kamonaTimeFormat}}
								</div>
								<div class="text-[#1A0C2F] opacity-[0.3] text-[16px] font-medium leading-normal">
									Mins
								</div>
							</div>
							<div class="relative -top-[10px]">
								<ng-container *ngTemplateOutlet="dot"></ng-container>
							</div>
							<div class="flex flex-col text-center">
								<div class="text-[#1A0C2F] leading-normal text-[40px] font-bold">
									{{countdown?.second | kamonaTimeFormat}}
								</div>
								<div class="text-[#1A0C2F] opacity-[0.3] text-[16px] font-medium leading-normal">
									Secs
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</dialog>

<ng-template #dot>
	<svg width="6" height="23" viewBox="0 0 6 23" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path opacity="0.3" d="M3.27545 22.0515C2.5747 22.0515 1.97337 21.8005 1.47148 21.2987C0.969584 20.7968 0.718637 20.1954 0.718637 19.4947C0.718637 18.7939 0.969584 18.1926 1.47148 17.6907C1.97337 17.1888 2.5747 16.9379 3.27545 16.9379C3.97621 16.9379 4.57754 17.1888 5.07943 17.6907C5.58133 18.1926 5.83227 18.7939 5.83227 19.4947C5.83227 19.9587 5.7139 20.3848 5.47716 20.7731C5.24989 21.1613 4.94212 21.4738 4.55386 21.7106C4.17508 21.9379 3.74894 22.0515 3.27545 22.0515ZM3.27545 5.85831C2.5747 5.85831 1.97337 5.60736 1.47148 5.10547C0.969584 4.60357 0.718637 4.00225 0.718637 3.30149C0.718637 2.60073 0.969584 1.99941 1.47148 1.49751C1.97337 0.99562 2.5747 0.744674 3.27545 0.744674C3.97621 0.744674 4.57754 0.99562 5.07943 1.49751C5.58133 1.99941 5.83227 2.60073 5.83227 3.30149C5.83227 3.76551 5.7139 4.19164 5.47716 4.5799C5.24989 4.96816 4.94212 5.28066 4.55386 5.5174C4.17508 5.74467 3.74894 5.85831 3.27545 5.85831Z" fill="#1A0C2F"/>
	</svg>
</ng-template>
